import React from "react";
import { DivSelectBoxArea, DivSelectBoxTitle, SelectDivArea } from "./ReceiptStyle";
import InnerDivCpnt from "./InnerDivCpnt";

// title: string, placeHolder: string, options: []
// options ex) [{view: "홍길동", data: "11111"}]
const SelectDropCpnt = (props) => {
  const { title, placeHolder, options, viewData, setData, openTarget, setOpenTarget } = props;
  return (
    <SelectDivArea>
      <DivSelectBoxTitle>{title}</DivSelectBoxTitle>
      <DivSelectBoxArea>
        <InnerDivCpnt
          placeHolder={placeHolder}
          options={options}
          viewData={viewData}
          setData={setData}
          cpmtTarget={"DR"}
          openTarget={openTarget}
          setOpenTarget={setOpenTarget}
        />
      </DivSelectBoxArea>
    </SelectDivArea>
  );
};

export default React.memo(SelectDropCpnt);
